import React, { useState } from 'react'
import { Image, Divider, App } from 'antd'
import CopyIcon from "../../../assets/icons/copy.svg"
import Whatsapp from "../../../assets/icons/whatsapp.svg"
import Mail from "../../../assets/icons/mail.svg"
import { CheckOutlined } from "@ant-design/icons"
import CustomButton from '../../../components/CustomButton/Button'
import CustomModal from '../../../components/CustomModal/CustomModal'
import { sendDepositDetails } from '../../../redux/slices/ProfileSlice'
import { capitalizeEntireWord } from '../../../helpers/helpers'
import { useDispatch, useSelector } from "react-redux";
import { GLOBAL_CONSTANTS, TITLE_TXT, SUCCESS_MSGS, BTN_TXT } from '../../../constants/constants'
import EscrowDetail from '../../../components/Details/EscrowDetail'
import ShareDetail from '../../../components/Details/ShareDetail'


const Deposit = ({ escrowBankDetailsData }) => {
    const { message } = App.useApp();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [openShareModal, setOpenShareModal] = useState(false);

    const copyable = {
        icon: [<Image preview={false} src={CopyIcon} alt='Copy Icon' key="copy-icon" />, <CheckOutlined key="copy-icon" />],
    }

    const handleSendDeposit = async () => {
        const payload = {
            email: user?.email,
            name: user?.userName,
            beneficiaryName: escrowBankDetailsData?.accHolderName,
            escrowBankName: escrowBankDetailsData?.bankName,
            escrowBranchName: escrowBankDetailsData?.branchName,
            escrowAccountNumber: escrowBankDetailsData?.accNum,
            escrowIfscCode: escrowBankDetailsData?.ifscCode,
        };

        const res = await dispatch(sendDepositDetails(payload))

        if (res.payload.statusCode === 200) {
            message.success(SUCCESS_MSGS.ECW_DET_SUC_MSG);
            setOpenShareModal(false)
        }
    };

    const shareContent = (
        <>
            <Divider style={{ marginTop: 15, border: "1.49px solid #E5E5E5" }} />
            <div className='share-content-container'>
                <ShareDetail
                    popTitle={TITLE_TXT.DEPO_DET_TO_WHATSAPP_CONFIRM_TXT}
                    onConfirm={() => { }}
                    icon={Whatsapp}
                    shareDesc={GLOBAL_CONSTANTS.WHATSAPP}
                />
                <ShareDetail
                    popTitle={TITLE_TXT.DEPO_DET_TO_EMAIL_CONFIRM_TXT}
                    onConfirm={handleSendDeposit}
                    icon={Mail}
                    shareDesc={GLOBAL_CONSTANTS.EMAIL}
                />
            </div>
        </>
    )

    return (
        <div className='wallet-account-details-container'>
            <EscrowDetail
                vertical
                gap="small"
                title={TITLE_TXT.ECW_BEN_ACC_NAME}
                descLevel={5}
                copyable={copyable}
                desc={capitalizeEntireWord(escrowBankDetailsData?.accHolderName)}
            />
            <EscrowDetail
                vertical
                gap="small"
                title={TITLE_TXT.ECW_BANK_NAME}
                descLevel={5}
                copyable={copyable}
                desc={capitalizeEntireWord(escrowBankDetailsData?.bankName)}
            />
            <EscrowDetail
                vertical
                gap="small"
                title={TITLE_TXT.ECW_BRANCH_NAME}
                descLevel={5}
                copyable={copyable}
                desc={capitalizeEntireWord(escrowBankDetailsData?.branchName)}
            />
            <EscrowDetail
                vertical
                gap="small"
                title={TITLE_TXT.ECW_BANK_ACC_NUM}
                descLevel={5}
                copyable={copyable}
                desc={capitalizeEntireWord(escrowBankDetailsData?.accNum)}
            />
            <EscrowDetail
                vertical
                gap="small"
                title={TITLE_TXT.ECW_IFSC_CODE}
                descLevel={5}
                copyable={copyable}
                desc={capitalizeEntireWord(escrowBankDetailsData?.ifscCode)}
            />
            <CustomButton
                block
                color="primary"
                variant="outlined"
                onClick={() => setOpenShareModal(true)}
                style={{ color: "#294DD8", fontWeight: 600, borderRadius: 8 }}
            >
                {BTN_TXT.SHARE}
            </CustomButton>
            <CustomModal
                title={GLOBAL_CONSTANTS.SHARE_TXT}
                open={openShareModal}
                centered
                onCancel={() => setOpenShareModal(false)}
                content={shareContent}
            />
        </div>
    )
}

export default Deposit